import { createFeatureScope } from 'bundles/product-features';

export const { ProductFeaturesQuery, withProductFeatures, useProductFeatures } = createFeatureScope({
  enterprise: {
    enableOrgHomepage: true,
    enableOrgHomepageAutoJoinProgram: false,
    enableForceSsoLoginV2Beta: false,
    enableUnifiedSso: false,
  },
  diagnostics: {
    enableSkillsDiagnostics: true,
  },
});
